import { render } from "./VentanaAjustes.vue?vue&type=template&id=f8c02df0&scoped=true"
import script from "./VentanaAjustes.vue?vue&type=script&lang=js"
export * from "./VentanaAjustes.vue?vue&type=script&lang=js"

import "./VentanaAjustes.vue?vue&type=style&index=0&id=f8c02df0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8c02df0"]])

export default __exports__